import { DatePipe } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  OnInit,
  Input,
  Output,
  ViewChild,
  ElementRef
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import saveAs from 'file-saver';
import {
  EventType,
  ProgramTypesGUID
} from '../../../../../models/_enum-collections';
import { CustomerAcknowledgement } from '../../../../../models/customer-ack.model';
import { DeclineReason } from '../../../../../models/decline-reason.model';
import { EventDetails } from '../../../../../models/event-detail.model';
import { EventL1InternalStatus } from '../../../../../models/event-l1-internal-status.model';
import { EventL2InternalStatus } from '../../../../../models/event-l2-internal-status.model';
import { EventPmoNextSteps } from '../../../../../models/event-pmo-next-steps.model';
import { EventPoeDocument } from '../../../../../models/event-poe-document.model';
import { ProgramDocument } from '../../../../../models/event-registration-document.model';
import { EventTaskOwner } from '../../../../../models/event-task-owner.model';
import { MilestonePaymentStatus } from '../../../../../models/milestone-payment-status.model';
import { ProgramSharedService } from '../../../../common/program-shared.service';
import { CommonSharedModule } from '../../../../common/shared.module';
import { EventEditService } from '../../../../services/event-edit.service';
import programConfigJson from '../events-config.json';

@Component({
  selector: 'app-event-details-tab',
  templateUrl: './event-details-tab.component.html',
  styleUrls: ['./event-details-tab.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class EventDetailsTabComponent implements OnInit {
  @Input() eventRegistrationId!: number;
  @Output() refreshEventDetails = new EventEmitter();
  @Input() programTypeGUID!: string;
  @ViewChild('fileInputUpload', { static: true }) myfileInput!: ElementRef;

  formEventDetails!: FormGroup;
  isReadonlyEng = true;
  btnNavEngDetails = false;
  maxYearDate!: Date;

  msgsEngDetails!: any[];
  updateEventDetails!: EventDetails;
  taskOwnerDrpdwn!: EventTaskOwner[];
  pmoNextStepStatus!: EventPmoNextSteps[];
  l1InternalStatuses!: EventL1InternalStatus[];
  l2InternalStatuses!: EventL2InternalStatus[];
  milestonePaymentStatuses!: MilestonePaymentStatus[];
  declineReasons!: DeclineReason[];
  dateTime = new Date();
  yearRange = '';
  isEventExtendedEnable = false;
  loading = false;
  eventExpiryDays = 90;
  mrppExpiryDays = 30;
  hasCustomerAcknowledgement!: boolean;
  loadcustomAck = false;
  customerAcknowledgement = 'CustomerAcknowledgement';
  fileUploadHeader = 'Upload Customer Acknowledgement';
  storeCustAckFile!: CustomerAcknowledgement;
  customerAck!: CustomerAcknowledgement[];
  submitAck!: ProgramDocument;
  // eslint-disable-next-line no-empty-pattern
  filesUpload: any = ([] = []);
  umsgs: any[] = [];
  fileUploadSpinners: boolean[] = [];
  downloadSpin: boolean[] = [];
  formData!: FormData;
  customerAcknowledgementTemplate =
    'Action Required to Approve  _Customer Name_ Nomination for _Workshop Name_ _Partner Name_.oft';
  isMRPPProgram = false;
  isDealAssociation!: boolean;
  pmoNextStep_Customer_Ack_Expiration_Reminder_Send = 9;
  opsStatus_Customer_Ack_Expiration_Date_not_commit = 4;

  constructor(
    private eventEditService: EventEditService,
    private formBuilder: FormBuilder,
    private programSharedService: ProgramSharedService
  ) {
    this.dateTime.setDate(this.dateTime.getDate());
    this.yearRange =
      (new Date().getFullYear() - 230).toString() +
      ':' +
      (new Date().getFullYear() + 250);
  }

  ngOnInit() {
    this.isMRPPProgram =
      this.programTypeGUID !== undefined &&
      this.programTypeGUID == ProgramTypesGUID.MRPP;

    this.formEventDetails = this.formBuilder.group({
      qualifiedAmount: [''],
      taskOwner: [''],
      pMONextSteps: [''],
      t1InternalStatus: [''],
      opsStatus: [''],
      eligibleDate: [''],
      day90ExpirationDate: [''],
      daysLeftFromDay90ExpirationDate: [''],
      daysLeftFromDay30ExpirationDate: [''],
      eventDate: [''],
      cancelledDate: [''],
      extendedExpirationDate: [null],
      isEventExtended: [''],
      market: [''],
      milestonePaymentStatus: [''],
      declineReason: [''],
      committedDate: [''],
      daysSinceCustomer: [''],
      thirtyDayReminderSentDate: [''],
      day30ExpirationDate: [''],
      activityEligibilityEndDate: [''],
      committedEmailSent: [''],
      daysSinceCommittedEmailSent: [''],
      reminderSentDate: [''],
      customerAckStatus: ['']
    });
    this.formEventDetails.disable();

    this.getTaskOwnerList();
    this.getPMONextStepsDropDown();
    this.getL1InternalStatusList();
    this.getL2InternalStatusList();
    this.getEventDetails(this.eventRegistrationId);
    this.getAllMilestonePaymentStatuses();
    this.getEventDeclineReasons();
    this.getCustomerAckFile();
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  getTaskOwnerList() {
    this.eventEditService.getTaskOwnerDropDown().subscribe(result => {
      this.taskOwnerDrpdwn = result;
    });
  }

  getPMONextStepsDropDown() {
    this.eventEditService.getPMONextStepsDropDown().subscribe(result => {
      if (this.isMRPPProgram) {
        result = result.filter(
          x =>
            x.eventPmonextStepId !=
            this.pmoNextStep_Customer_Ack_Expiration_Reminder_Send
        );
      }
      this.pmoNextStepStatus = result;
    });
  }

  getL1InternalStatusList() {
    this.eventEditService.getL1InternalStatusDropDown().subscribe(result => {
      this.l1InternalStatuses = result;
    });
  }

  getL2InternalStatusList() {
    this.eventEditService.getL2InternalStatusDropDown().subscribe(result => {
      if (this.isMRPPProgram) {
        result = result.filter(
          x =>
            x.eventL2internalStatusId !=
            this.opsStatus_Customer_Ack_Expiration_Date_not_commit
        );
      }
      this.l2InternalStatuses = result;
    });
  }

  getAllMilestonePaymentStatuses() {
    this.eventEditService
      .getAllMilestonePaymentStatuses(this.programTypeGUID)
      .subscribe(result => {
        this.milestonePaymentStatuses = result;
      });
  }

  getEventDeclineReasons() {
    this.eventEditService.getEventDeclineReasons().subscribe(result => {
      this.declineReasons = result;
    });
  }

  getEventDetails(eventRegistrationId: number) {
    this.msgsEngDetails = [];
    this.loading = true;
    this.eventEditService
      .getEventDetails(eventRegistrationId)
      .subscribe(result => {
        const datePipe = new DatePipe('en-US');
        const eligibleDate1 = datePipe.transform(
          result.eligibleDate,
          'MM/dd/yyyy'
        );
        const eventDate = datePipe.transform(
          new Date(result.eventDate).toISOString(),
          'MM/dd/yyyy'
        );
        const day90ExpirationDate = datePipe.transform(
          result.day90ExpirationDate,
          'MM/dd/yyyy'
        );
        const cancelledDate = datePipe.transform(
          result.cancelledDate,
          'MM/dd/yyyy'
        );
        const extendedExpirationDate = datePipe.transform(
          result.extendedExpirationDate,
          'MM/dd/yyyy'
        );
        this.isEventExtendedEnable =
          result.isEventExtended != null ? result.isEventExtended : false;
        const committedDate = datePipe.transform(
          result.committedDate,
          'MM/dd/yyyy'
        );
        const m2ExpirationDate =
          result.m2ExpirationDate != null
            ? datePipe.transform(
                new Date(result.m2ExpirationDate).toISOString(),
                'MM/dd/yyyy'
              )
            : null;
        const thirtyDayReminderSentDate = datePipe.transform(
          result.thirtyDayReminderSentDate,
          'MM/dd/yyyy'
        );
        const day30ExpirationDate = datePipe.transform(
          result.day30ExpirationDate,
          'MM/dd/yyyy'
        );
        const activityEligibilityEnd = datePipe.transform(
          result.activityEligibilityEndDate,
          'MM/dd/yyyy'
        );
        const committedEmailSent = datePipe.transform(
          result.committedEmailSent,
          'MM/dd/yyyy'
        );
        const reminderSentDate = datePipe.transform(
          result.reminderSentDate,
          'MM/dd/yyy'
        );
        this.formEventDetails.patchValue({
          qualifiedAmount: result.qualifiedAmount,
          market:
            result.eventTypeId == EventType.DealAssociation ||
            result.eventTypeId == EventType.DealAssociationRequestforProposal
              ? 'N/A'
              : result.market,
          eligibleDate: eligibleDate1,
          day90ExpirationDate: day90ExpirationDate,
          daysLeftFromDay90ExpirationDate:
            result.daysLeftFromDay90ExpirationDate,
          eventDate: eventDate,
          cancelledDate: cancelledDate,
          isEventExtended: result.isEventExtended,
          extendedExpirationDate: extendedExpirationDate,
          committedDate: committedDate,
          daysSinceCustomer: result.daysSinceCustomer,
          thirtyDayReminderSentDate: thirtyDayReminderSentDate,
          day30ExpirationDate: day30ExpirationDate,
          activityEligibilityEndDate: activityEligibilityEnd,
          committedEmailSent: committedEmailSent,
          customerAckStatus: result.customerAckStatus,
          daysSinceCommittedEmailSent: result.daysSinceCommittedEmailSent,
          reminderSentDate: reminderSentDate,
          daysLeftFromDay30ExpirationDate:
            result.daysLeftFromDay30ExpirationDate
        });

        this.hasCustomerAcknowledgement = result.hasCustomerAcknowledgement;
        this.formEventDetails.controls['taskOwner'].setValue({
          eventTaskOwnerId: result.taskOwnerId,
          taskOwner: result.taskOwnerName
        });

        this.formEventDetails.controls['t1InternalStatus'].setValue({
          eventL1internalStatusId: result.eventL1internalStatusId,
          name: result.l1internalStatusName
        });

        this.formEventDetails.controls['opsStatus'].setValue({
          eventL2internalStatusId: result.eventL2internalStatusId,
          name: result.l2internalStatusName
        });

        this.formEventDetails.controls['pMONextSteps'].setValue({
          eventPmonextStepId: result.eventPmonextStepId,
          name: result.pmonextStepName
        });

        this.formEventDetails.controls['milestonePaymentStatus'].setValue({
          milestonePaymentStatusId: result.milestonePaymentStatusId,
          milestonePaymentStatusName: result.milestonePaymentStatusName
        });

        this.formEventDetails.controls['declineReason'].setValue({
          eventDeclineReasonId: result.eventDeclineReasonId,
          declineReason: result.declineReasonName
        });

        this.programSharedService.setMilestone2ExpirationDate(
          m2ExpirationDate || ''
        );
        this.programSharedService.setEventType(result.eventTypeId);

        this.isDealAssociation =
          result.eventTypeId == EventType.DoMorewithME3DealAssociation;

        this.loading = false;
      });
  }

  editEventDetails() {
    this.isReadonlyEng = false;
    this.btnNavEngDetails = true;
    this.formEventDetails.enable();
  }

  editEventDetailsCancel() {
    this.getEventDetails(this.eventRegistrationId);
    this.isReadonlyEng = true;
    this.btnNavEngDetails = false;
    this.formEventDetails.disable();
  }

  onSubmitEventDetails(formEventDetails: FormGroup) {
    const datePipe = new DatePipe('en-US');

    if (formEventDetails.status == 'VALID') {
      const committedDate = datePipe.transform(
        this.formEventDetails.controls['committedDate'].value,
        'MM/dd/yyyy'
      );

      const thirtyDayReminderSentDate = datePipe.transform(
        this.formEventDetails.controls['thirtyDayReminderSentDate'].value,
        'MM/dd/yyyy'
      );

      const day30ExpirationDate = datePipe.transform(
        this.formEventDetails.controls['day30ExpirationDate'].value,
        'MM/dd/yyyy'
      );

      const committedEmailSent = datePipe.transform(
        this.formEventDetails.controls['committedEmailSent'].value,
        'MM/dd/yyyy'
      );

      const reminderSentDate = datePipe.transform(
        this.formEventDetails.controls['reminderSentDate'].value,
        'MM/dd/yyyy'
      );

      this.updateEventDetails = {
        eventRegistrationId: this.eventRegistrationId,
        qualifiedAmount: formEventDetails.controls['qualifiedAmount'].value,
        taskOwnerId:
          this.formEventDetails.controls['taskOwner'].value.eventTaskOwnerId !=
          null
            ? this.formEventDetails.controls['taskOwner'].value.eventTaskOwnerId
            : null,
        taskOwnerName:
          this.formEventDetails.controls['taskOwner'].value.taskOwner,
        eventPmonextStepId:
          this.formEventDetails.controls['pMONextSteps'].value
            .eventPmonextStepId != null
            ? this.formEventDetails.controls['pMONextSteps'].value
                .eventPmonextStepId
            : null,
        pmonextStepName:
          this.formEventDetails.controls['pMONextSteps'].value.name,
        eventL1internalStatusId:
          this.formEventDetails.controls['t1InternalStatus'].value
            .eventL1internalStatusId != null
            ? this.formEventDetails.controls['t1InternalStatus'].value
                .eventL1internalStatusId
            : null,
        l1internalStatusName:
          this.formEventDetails.controls['t1InternalStatus'].value.name,
        eventL2internalStatusId:
          this.formEventDetails.controls['opsStatus'].value
            .eventL2internalStatusId != null
            ? this.formEventDetails.controls['opsStatus'].value
                .eventL2internalStatusId
            : null,
        l2internalStatusName:
          this.formEventDetails.controls['opsStatus'].value.name,
        extendedExpirationDate:
          this.formEventDetails.controls['extendedExpirationDate'].value ===
          null
            ? new Date()
            : new Date(
                datePipe.transform(
                  this.formEventDetails.controls['extendedExpirationDate']
                    .value,
                  'MM/dd/yyyy'
                ) || ''
              ),
        isEventExtended:
          this.formEventDetails.controls['isEventExtended'].value,
        eligibleDate: this.formEventDetails.controls['eligibleDate'].value
          ? new Date(
              datePipe.transform(
                this.formEventDetails.controls['eligibleDate'].value,
                'MM/dd/yyyy'
              )!
            )
          : new Date(),
        milestonePaymentStatusId:
          this.formEventDetails.controls['milestonePaymentStatus'].value
            .milestonePaymentStatusId != null
            ? this.formEventDetails.controls['milestonePaymentStatus'].value
                .milestonePaymentStatusId
            : null,
        milestonePaymentStatusName:
          this.formEventDetails.controls['milestonePaymentStatus'].value
            .milestonePaymentStatusName,
        eventDeclineReasonId:
          this.formEventDetails.controls['declineReason'].value
            .eventDeclineReasonId != null
            ? this.formEventDetails.controls['declineReason'].value
                .eventDeclineReasonId
            : null,
        declineReasonName:
          this.formEventDetails.controls['declineReason'].value.declineReason,
        committedDate:
          committedDate == null ? new Date() : new Date(committedDate),
        thirtyDayReminderSentDate:
          thirtyDayReminderSentDate == null
            ? new Date()
            : new Date(thirtyDayReminderSentDate),
        day30ExpirationDate:
          day30ExpirationDate == null
            ? new Date()
            : new Date(day30ExpirationDate),
        committedEmailSent:
          committedEmailSent == null
            ? new Date()
            : new Date(committedEmailSent),
        reminderSentDate:
          reminderSentDate == null ? new Date() : new Date(reminderSentDate),
        isMRPPProgram: this.isMRPPProgram
      } as any;

      let workshopConfig = programConfigJson.program
        ?.find(p => p.programTypeGuid == this.programTypeGUID)
        ?.page.workshop.find(
          w => w.workshopTypeId == this.programSharedService.getEventType()
        );
      if (!workshopConfig) {
        workshopConfig = programConfigJson.program
          ?.find(p => p.programTypeGuid == this.programTypeGUID)
          ?.page.workshop.find(w => w.workshopTypeId == null);
      }
      this.updateEventDetails.expiryDays =
        workshopConfig && workshopConfig.model
          ? workshopConfig.model.expiryDays
          : this.programTypeGUID == ProgramTypesGUID.Events
            ? this.eventExpiryDays
            : this.mrppExpiryDays;

      this.eventEditService
        .updateEventDetails(this.updateEventDetails)
        .subscribe(
          () => {
            this.formEventDetails.disable();
            this.btnNavEngDetails = !this.btnNavEngDetails;
            this.isReadonlyEng = !this.isReadonlyEng;
            this.getEventDetails(this.eventRegistrationId);
            this.refreshEventDetails.emit();
            this.msgsEngDetails = [];
            this.msgsEngDetails.push({
              severity: 'success',
              detail: !this.isMRPPProgram
                ? 'Event Details Updated Successfully'
                : 'Engagement Details Updated Successfully'
            });
          },
          () => {
            this.msgsEngDetails = [];
            this.msgsEngDetails.push({
              severity: 'warn',
              detail: !this.isMRPPProgram
                ? 'Sorry an Error Occured while Updating Event Details'
                : 'Sorry an Error Occured while Updating Engagement Details'
            });
          }
        );
    }
  }
  onCheckedEventExtended() {
    this.isEventExtendedEnable =
      !this.formEventDetails.controls['isEventExtended'].value;
  }

  refreshEventDetailsTab() {
    this.getEventDetails(this.eventRegistrationId);
  }

  get EventType(): typeof EventType {
    return EventType;
  }

  checkEventType(eventType: EventType) {
    return this.programSharedService.checkEventType(eventType);
  }

  getCustomerAckFile(): void {
    this.eventEditService
      .getCustomerAcknowledgementFile(this.eventRegistrationId.toString())
      .subscribe(files => {
        this.customerAck = files;
        this.downloadSpin = this.customerAck.map(() => false);
      });
  }

  openDocumentUpload() {
    this.loadcustomAck = true;
  }

  closeDocumentUpload() {
    this.loadcustomAck = false;
    this.clearHtmlFileInput();
    this.storeCustAckFile = {} as CustomerAcknowledgement;
    this.filesUpload = [];
  }

  private clearHtmlFileInput() {
    this.myfileInput.nativeElement.value = '';
  }

  uploadFile(event: string | any[]) {
    for (const fileUpload of event) {
      const ext = fileUpload.name.substring(
        fileUpload.name.lastIndexOf('.') + 1
      );
      if (
        ext.toLowerCase() === 'pdf' ||
        ext.toLowerCase() === 'jpeg' ||
        ext.toLowerCase() === 'png' ||
        ext.toLowerCase() === 'jpg' ||
        ext.toLowerCase() === 'bmp' ||
        ext.toLowerCase() === 'gif' ||
        ext.toLocaleLowerCase() === 'tiff'
      ) {
        if (fileUpload.size > 10485760) {
          this.umsgs.push({
            severity: 'error',
            detail: fileUpload.name + 'files is greater than 10 Mb'
          });
          setTimeout(() => {
            this.umsgs = [];
          }, 6000);
        } else {
          const newFile = { fileName: fileUpload.name, size: fileUpload.size };
          const formData = new FormData();
          if (
            this.filesUpload.find(
              (a: { fileName: string }) => a.fileName === newFile.fileName
            ) === undefined
          ) {
            if (
              this.filesUpload.length === 0 ||
              this.filesUpload.length !== 1
            ) {
              this.filesUpload.push(newFile);
              formData.append('file', fileUpload, fileUpload.name);
              this.formData = formData;
            } else {
              this.umsgs = [];
              this.umsgs.push({
                severity: 'error',
                detail: 'Possible upload only one file in list'
              });
              setTimeout(() => {
                this.umsgs = [];
              }, 6000);
            }
          } else {
            this.umsgs = [];
            this.umsgs.push({
              severity: 'error',
              detail: fileUpload.name + ' file already exits in list'
            });
            setTimeout(() => {
              this.umsgs = [];
            }, 6000);
          }
        }
      } else {
        this.umsgs.push({
          severity: 'error',
          detail: 'Image or Pdf file Accepetable'
        });
        setTimeout(() => {
          this.umsgs = [];
        }, 6000);
      }
    }
    this.myfileInput.nativeElement.value = '';
  }

  saveFile() {
    if (this.formData === undefined || this.formData === null) {
      this.umsgs = [];
      const noFileError = 'Upload Customer Acknowledgement file to Submit';
      this.umsgs.push({ severity: 'error', detail: noFileError });
      setTimeout(() => {
        this.umsgs = [];
      }, 4000);
    } else {
      this.fileUploadSpinners = [];
      this.fileUploadSpinners.push(true);
      this.uploadDocToBlob(this.formData);
    }
  }

  uploadDocToBlob(formData: any) {
    const subFolderName = this.customerAcknowledgement.toLocaleLowerCase();
    this.eventEditService
      .uploadPOEDocToBlob(
        formData,
        this.eventRegistrationId.toString(),
        subFolderName
      )
      .subscribe(
        (results: any) => {
          this.storeCustAckFile = results;
          const finalFile = this.filesUpload.find(
            (a: { fileName: any }) => a.fileName === results.fileName
          );
          const idx = this.filesUpload.indexOf(finalFile);
          this.fileUploadSpinners[idx] = false;
          this.submitCustomerAckFile();
        },
        error => {
          this.umsgs = [];
          if (error.status === 500) {
            this.umsgs.push({ severity: 'error', detail: error.statusText });
            setTimeout(() => {
              this.umsgs = [];
            }, 4000);
          } else if (error.status === 502) {
            this.umsgs.push({ severity: 'error', detail: error.statusText });
            setTimeout(() => {
              this.umsgs = [];
            }, 4000);
          } else {
            this.umsgs.push({
              severity: 'warn',
              detail: 'Sorry an Error Occured while uploading a file'
            });
            this.filesUpload = [];
            this.fileUploadSpinners = [];
            this.formData = {} as FormData;
            setTimeout(() => {
              this.umsgs = [];
            }, 4000);
          }
        }
      );
  }

  submitCustomerAckFile() {
    this.submitAck = {
      eventRegistrationId: this.eventRegistrationId,
      fileName: this.storeCustAckFile.fileName || '',
      filePath: this.storeCustAckFile.url || ''
    } as ProgramDocument;

    this.eventEditService
      .updateCustomerAcknowledgement(this.submitAck)
      .subscribe(
        () => {
          this.formData = {} as FormData;
          this.closeDocumentUpload();
          this.getEventDetails(this.eventRegistrationId);
          this.getCustomerAckFile();
          this.refreshEventDetails.emit();
        },
        error => {
          if (error.status === 500) {
            this.umsgs = [];
            this.umsgs.push({ severity: 'error', detail: error.error });
            setTimeout(() => {
              this.umsgs = [];
            }, 2000);
          } else {
            this.umsgs.push({
              severity: 'warn',
              detail: 'Sorry an Error Occured while Changing Engagement'
            });
          }
        }
      );
  }

  downloadFile(index: string | number) {
    this.downloadSpin[index] = true;
    const document: EventPoeDocument = {
      eventId: this.eventRegistrationId,
      fileName: this.customerAck[index].fileName,
      documentType: this.customerAcknowledgement
    } as any;

    this.eventEditService
      .getFileSasUrl(document)
      .subscribe(downloadFileSasUrl => {
        setTimeout(() => {
          const custAck = this.customerAck.find(
            itm => itm.fileName === this.customerAck[index].fileName
          );
          const idx = this.customerAck.indexOf(
            custAck as CustomerAcknowledgement
          );
          this.downloadSpin[idx] = false;
        }, 5000);
        window.location.href = downloadFileSasUrl;
      });
  }

  deleteAttachment(index: number) {
    const document = new EventPoeDocument();
    document.eventId = this.eventRegistrationId;
    document.fileName = this.customerAck[index].fileName;
    document.documentType = this.customerAcknowledgement.toLocaleLowerCase();

    const a = this.customerAck.splice(index, 1);
    this.downloadSpin.splice(index, 1);
    if (this.filesUpload.length > 0) {
      for (let i = 0; i < this.filesUpload.length; i++) {
        if (this.filesUpload[i].fileName === a[0].fileName) {
          this.filesUpload.splice(i, 1);
        }
      }
    }

    this.eventEditService.deleteFile(document).subscribe(del => {
      if (del) {
        this.getCustomerAckFile();
      }
    });
  }

  async downloadOFT() {
    const document = new EventPoeDocument();
    document.fileName = this.customerAcknowledgementTemplate;
    this.eventEditService
      .downloadOFTTemplate(document)
      .subscribe((result: any) => {
        if (result.type !== 'text/plain') {
          if (result.type === HttpEventType.Response) {
            const blob = new Blob([result.body]);
            saveAs(blob, 'Customer Acknowledgement Email Template.oft');
          }
        }
      });
  }

  formatBytes(bytes: number, decimals: number) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  canShowPreviewButton(fileName: string) {
    const extensions: string[] = [
      '.pdf',
      '.jpeg',
      '.png',
      '.jpg',
      '.bmp',
      '.gif'
    ];
    return extensions.some(v => fileName.toLowerCase().endsWith(v));
  }
}
